import { PageHeader } from "@/components/page-header";
import { useT } from "@/lib/i18n";

/**
 * Tiny client wrapper around `PageHeader` so the MCP page (an RSC) can
 * still render i18n labels. Splitting it out keeps the page itself a
 * server component, which lets us load the seed data with `gatewayFetch`
 * during SSR.
 */
export function McpPageHeader() {
  const t = useT();
  return (
    <PageHeader
      eyebrow={t("common.eyebrow.workspace")}
      title={t("mcp.title")}
      subtitle={t("mcp.subtitle")}
    />
  );
}
